import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { KeyRound, Loader2, CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';
import { customerAuth } from '../lib/api';

export const ResetPasswordDialog = ({ open, token, onOpenChange, onDone }) => {
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    if (pw.length < 6) { toast.error('Password kam se kam 6 characters ka ho'); return; }
    if (pw !== pw2) { toast.error('Dono passwords match nahi kar rahe'); return; }
    setBusy(true);
    try {
      await customerAuth.resetPassword(token, pw);
      setDone(true);
      toast.success('Password reset ho gaya. Ab sign in karein.');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Reset link invalid ya expire ho gaya');
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="reset-password-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><KeyRound className="w-5 h-5 text-orange-500" /> Set New Password</DialogTitle>
        </DialogHeader>
        {done ? (
          <div className="text-center py-3">
            <CheckCircle2 className="w-10 h-10 text-green-600 mx-auto mb-2" />
            <p className="text-[13px] text-neutral-700">Password update ho gaya. Ab apne naye password se login karein.</p>
            <Button data-testid="reset-done-login-button" className="w-full mt-3 bg-orange-500 hover:bg-orange-600" onClick={() => { onOpenChange(false); onDone && onDone(); }}>Go to Sign In</Button>
          </div>
        ) : (
          <div className="space-y-3">
            <div>
              <Label className="text-[12px] text-neutral-600">New password</Label>
              <Input data-testid="reset-password-input" type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="min 6 characters" className="mt-1" />
            </div>
            <div>
              <Label className="text-[12px] text-neutral-600">Confirm password</Label>
              <Input data-testid="reset-password-confirm-input" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="mt-1" />
            </div>
            <Button data-testid="reset-password-submit-button" onClick={submit} disabled={busy} className="w-full bg-orange-500 hover:bg-orange-600">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Update Password'}
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ResetPasswordDialog;
